/**
 * Client-safe utility functions for custom fields
 * These functions can be used on both client and server
 */

export interface CustomFieldDefinition {
  id: string;
  name: string;
  label: string;
  type: "text" | "number" | "date" | "boolean" | "tags";
  isRequired: boolean;
}

export interface CustomFieldValue {
  id: string;
  fieldId?: string;
  field?: CustomFieldDefinition;
  valueText?: string | null;
  valueNumber?: number | null;
  valueDate?: Date | string | null;
  valueBoolean?: boolean | null;
}

/**
 * Parse les valeurs de champs personnalisés depuis la base de données
 * Cette fonction est client-safe et peut être utilisée côté client
 */
export function parseCustomFieldValue(
  fieldDef: CustomFieldDefinition,
  value: CustomFieldValue,
): any {
  if (fieldDef.type === "tags") {
    if (value.valueText) {
      try {
        return JSON.parse(value.valueText);
      } catch {
        return [];
      }
    }
    return [];
  } else if (fieldDef.type === "text") {
    return value.valueText;
  } else if (fieldDef.type === "number") {
    return value.valueNumber;
  } else if (fieldDef.type === "date") {
    return value.valueDate;
  } else if (fieldDef.type === "boolean") {
    return value.valueBoolean;
  }
  return null;
}

